export const   fetch= 'FETCH-USER-LISTINGS'
export const   addUserListing= 'ADD-USER-LISTING'
export const   fetched= 'FETCHED-USER-LISTINGS'
export const   remove= 'REMOVE-USER-LISTING'
export const   error= 'FETCHING-ERROR-USER-LISTINGS'
